<div class="w-inherit flex items-center">
    <div class="flex items-center">
        <button mat-icon-button (click)="toggleSidenav()" class="mobile-menu-btn">
            <mat-icon>menu</mat-icon>
        </button>
        <a routerLink="/"
            class="text-2xl font-bold tracking-tight hover:opacity-80 transition-opacity no-underline text-inherit ml-2">{{appName}}</a>

        <!-- Desktop Navigation Categories -->
        <nav class="hidden lg:flex items-center h-[64px] ml-6" (mouseleave)="onMouseLeave()">
            @for (cat of categories; track cat) {
            <div class="navigation-button relative inline-block" (mouseenter)="onMouseEnter(cat)">
                <button mat-button
                    class="!px-5 !rounded-none !m-0 !text-[15px] transition-colors uppercase tracking-wide">
                    <span>{{cat}}</span>
                </button>
                <lib-nav-links class="absolute p-2 block bg-slate-800 rounded"
                    *ngIf="cat === (selectedCategory$ | async) && (menuItems$ | async)?.length"
                    [groups]="(menuItems$ | async) || []"></lib-nav-links>
            </div>
            }
        </nav>
    </div>
    <span class="flex-auto"></span>
    <div class="flex gap-2 items-center">
        @if (isAdmin) {
        <a [href]="coreAppUrl" mat-icon-button matTooltip="Client UI">
            <mat-icon>computer</mat-icon>
        </a>
        <a [href]="adminAppUrl" mat-icon-button matTooltip="Admin UI">
            <mat-icon>admin_panel_settings</mat-icon>
        </a>
        }

        <!-- Global Search Trigger -->
        <button mat-icon-button (click)="openSearch()" matTooltip="Quick Search (Ctrl+K)">
            <mat-icon>search</mat-icon>
        </button>

        <button mat-icon-button (click)="bookmarkSite()" matTooltip="Bookmark this page">
            <mat-icon>bookmark_add</mat-icon>
        </button>

        <!-- More Options Menu -->
        <button mat-icon-button [matMenuTriggerFor]="optionsMenu" matTooltip="More Options">
            <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #optionsMenu="matMenu" class="modern-menu">
            <button mat-menu-item (click)="toggleThemeStyle()">
                <mat-icon>{{ isDarkMode ? 'light_mode' : 'dark_mode' }}</mat-icon>
                <span>{{ isDarkMode ? 'Light Mode' : 'Dark Mode' }}</span>
            </button>
            <button mat-menu-item (click)="generateBookmarkFolder()">
                <mat-icon>folder_special</mat-icon>
                <span>Export Bookmarks</span>
            </button>
            <a mat-menu-item routerLink="/about">
                <mat-icon>info</mat-icon>
                <span>About</span>
            </a>
        </mat-menu>
        @if (currentUser) {
        <div class="user-menu">
            <button mat-button [matMenuTriggerFor]="menu" class="user-button"
                style="display: flex; align-items: center; gap: 8px;">
                @if (currentUser.picture) {
                <img [src]="currentUser.picture" [alt]="currentUser.name || 'User'"
                    style="width: 32px; height: 32px; border-radius: 50%; object-fit: cover;">
                } @else {
                <mat-icon>account_circle</mat-icon>
                }
                @if (currentUser.name) {
                <span class="user-name">{{ currentUser.name }}</span>
                }
                <mat-icon>arrow_drop_down</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
                @if (currentUser.email) {
                <button mat-menu-item disabled>
                    <mat-icon>email</mat-icon>
                    <span>{{ currentUser.email }}</span>
                </button>
                <mat-divider></mat-divider>
                }
                <button mat-menu-item (click)="logout()">
                    <mat-icon>logout</mat-icon>
                    <span>Logout</span>
                </button>
            </mat-menu>
        </div>
        }
    </div>
</div>